import React from "react";
import { Typography } from "@material-ui/core";
import DPHeadCellWithTooltip from "Components/DP/DPHeadCell/DPHeadCell";

const NetEarningsReportedHeadCell = () => {
  return <DPHeadCellWithTooltip
    label="Net Earnings Reported"
    content={
      <Typography variant="body1">
        Earnings reported through final payroll journal
      </Typography>
    }
  />;
};

export default NetEarningsReportedHeadCell;
